<template>
  <v-row>
    <v-col cols="5" class="pt-2">
      <v-select
        v-model="types"
        :items="taskTypes"
        label="Please select task types"
        single-line
        dense
        chips
        multiple
      ></v-select>
    </v-col>
    <v-col cols="12" class="pt-2">
      <highcharts v-if="taskReport" :options="taskReport"></highcharts>
    </v-col>
    <v-dialog
      v-if="showModal"
      v-model="showModal"
      width="1300"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Task history</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <task-history :assignedToId="selectUserId" :incompleteTasks="true"></task-history>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { TASK_EVENT_REPORT_QUERY, TASK_TYPE_QUERY } from "@/graphql/queries/task";
import TaskHistory from "@/components/task/components/TaskHistory";

export default {
  name: "SupportTaskReporting",
  components: {
    TaskHistory,
  },
  data() {
    return {
      taskEvents: [],
      taskReport: null,
      showModal: false,
      selectUserId: null,
      selectedUserName: "",
      types: [],
    };
  },
  methods: {
    pointClick(selectUserId) {
      this.showModal = true;
      this.selectUserId = selectUserId;
    },
  },
  apollo: {
    taskTypes: {
      query: TASK_TYPE_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.taskTypes.map((item) => {
          return {
            text: item.title,
            value: item.id,
          };
        });
      },
    },
    taskEvents: {
      query: TASK_EVENT_REPORT_QUERY,
      variables() {
        return {
          closedAt_Isnull: true,
          taskType_Id_In: this.types,
        };
      },
      fetchPolicy: "cache-and-network",
      skip() {
        return this.types.length == 0;
      },
      result(response) {
        if (response.data) {
          var data = response.data.taskEvents.edges;
          const dates = [...new Set(data.map((item) => item.node.taskEventDate))];

          const maxDate = this.$moment(
            Math.max(
              ...dates.map((element) => {
                return new Date(element);
              })
            )
          );
          const minDate = this.$moment(
            Math.min(
              ...dates.map((element) => {
                return new Date(element);
              })
            )
          );

          var days = [];
          var day = minDate;

          while (day <= maxDate) {
            days.push(day.format("YYYY-MM-DD"));
            day = day.clone().add(1, "days");
          }

          let coachData = {};
          let series = [];
          days.forEach((day) => {
            var tasks = data.filter((task) => this.$moment(task.node.taskEventDate).format("YYYY-MM-DD") == day);
            tasks.forEach((task) => {
              var dayData = {};
              if (task.node.assignedTo) {
                var name = `${task.node.assignedTo.firstName} ${task.node.assignedTo.lastName}`;
                if (name in coachData) {
                  if (day in coachData[name]["data"]) {
                    coachData[name]["data"][day] += 1;
                  } else {
                    coachData[name]["data"][day] = 1;
                  }
                } else {
                  var dayData = {};
                  dayData[day] = 1;

                  coachData[name] = {
                    name: name,
                    data: dayData,
                    userId: task.node.assignedTo.id,
                  };
                }
              } else {
                var name = "unassigned";
                if (name in coachData) {
                  if (day in coachData[name]["data"]) {
                    coachData[name]["data"][day] += 1;
                  } else {
                    coachData[name]["data"][day] = 1;
                  }
                } else {
                  var dayData = {};
                  dayData[day] = 1;

                  coachData[name] = {
                    name: name,
                    data: dayData,
                    userId: null,
                  };
                }
              }
            });
          });

          for (var key in coachData) {
            var obj = coachData[key];
            days.forEach((day) => {
              if (!(day in obj["data"])) {
                obj["data"][day] = 0;
              }
            });
            coachData[key] = obj;
          }

          for (var key in coachData) {
            var obj = coachData[key];

            var userData = {
              name: obj["name"],
              data: [],
            };

            days.forEach((day) => {
              userData.data.push([obj["userId"], obj["data"][day]]);
            });

            series.push(userData);
          }

          this.taskReport = {
            chart: {
              type: "column",
            },
            title: {
              text: "Incomplete tasks",
            },
            xAxis: {
              categories: days,
            },
            yAxis: {
              min: 0,
              title: {
                text: "Total support tasks",
              },
              stackLabels: {
                enabled: true,
              },
            },
            tooltip: {
              headerFormat: "<b>{point.x}</b><br/>",
              pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
            },
            plotOptions: {
              series: {
                allowPointSelect: true,
                point: {
                  events: {
                    click: ({ point }) => {
                      this.pointClick(point.name);
                    },
                  },
                },
              },
              column: {
                stacking: "normal",
                dataLabels: {
                  enabled: true,
                },
              },
            },
            credits: {
              enabled: false,
            },
            series: series,
          };
        }
      },
    },
  },
};
</script>
